<script setup lang="ts">
const { product, close } = useOfferFormDialog()
const { loadLayout, tooltips } = useLayout()
await loadLayout()

watch (product, (newProduct) => {
  if (newProduct) {
    useScript({ src: 'https://server.fillout.com/embed/v1/' })
  }
})

const content = computed(() => tooltips.value.get('offer-form') || null)

onUnmounted(() => {
  close()
})
</script>

<template>
  <LazyUiDialog
    name="offer-form-dialog"
    dialog-type="responsive"
  >
    <div v-if="product">
      <div class="offer-form__header">
        {{ content?.Title }} {{ product?.name || '' }}
      </div>
      <div class="offer-form__content">
        <StrapiBlocksText
          v-if="content"
          :nodes="content?.Richtext"
        />

        <div class="offer-form__image">
          <div class="offer-form__image-features">
            <span>{{ $t('Kies kleur en opstelling') }}</span>
            <span>{{ $t('Persoonlijk advies') }}</span>
            <span>{{ $t('Binnen 2 werkdagen reactie') }}</span>
          </div>
          <img
            v-if="product?.image"
            :src="`${product?.image}?f=rs:fit:400:291:0:0`"
            :alt="product?.name"
            width="400"
            height="291"
            loading="lazy"
          >
        </div>
      </div>
      <div
        class="offer-form__form"
        style="height:500px;"
        data-fillout-id="bBcmcoSrUdus"
        data-fillout-embed-type="standard"
        data-fillout-inherit-parameters
        :data-product_name="product.name"
        :data-sku="product.sku"
        :data-product_url="product.url"
        data-fillout-dynamic-resize
      />
    </div>
  </LazyUiDialog>
</template>

<style>
 @import url('~layers/app/components/Product/OfferFormDialog.css');
</style>
